export default __webpack_public_path__ + "static/media/progress.86edb274.svg";